import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IQuotation } from "src/models/Products/Quotation.models";

interface QuotationState {
    quotations: IQuotation[];
    quotationToEdit: IQuotation | null;
}

const initialState: QuotationState = {
    quotations: [],
    quotationToEdit: null,
};

const QuotationSlice = createSlice({
    name: "Quotation",
    initialState,
    reducers: {
    setQuotationList: (
        state,
        action: PayloadAction<IQuotation[]>
    ) => {
        state.quotations = action.payload;
    },
    concatListQuotation: (
        state: QuotationState,
        action: PayloadAction<IQuotation[]>
    ) => {
        state.quotations = [
            ...state.quotations.concat(action.payload),
        ];
    },
    setQuotationToEdit: (
        state,
        action: PayloadAction<IQuotation | null>
    ) => {
        state.quotationToEdit = action.payload;
    },
    setURLToQuotationToEdit: (
        state,
        action: PayloadAction<string | null>
    ) => {
        if (state.quotationToEdit)
        state.quotationToEdit.url = action.payload;
    },
    addQuotation: (state, action: PayloadAction<IQuotation>) => {
        state.quotations = [action.payload, ...state.quotations];
    },
    updateQuotation: (state, action: PayloadAction<IQuotation>) => {
        let itemIndex = state.quotations.findIndex(
            item => item.quotationId === action.payload.quotationId
        );
        if (itemIndex !== -1) state.quotations[itemIndex] = action.payload;
    },
    deleteQuotation: (state, action: PayloadAction<number>) => {
        const newArray = state.quotations.filter(
            item => item.quotationId !== action.payload
        );
        state.quotations = newArray;
    },
    },
});

export const {
    setQuotationList,
    concatListQuotation,
    setQuotationToEdit,
    setURLToQuotationToEdit,
    addQuotation,
    updateQuotation,
    deleteQuotation,
} = QuotationSlice.actions;

export default QuotationSlice.reducer;